<template>
    <form @submit.prevent="submit" id="postEditForm">
        <tabs class="tabs-simple">
            <tab id="basic" name="Alap adatok">
                <div class="row m-1">
                    <div class="col-8">
                        <div class="card">
                            <div class="card-header">
                                Tartalom
                            </div>
                            <div class="card-body">
                                <editor ref="editor"
                                    :config="editorConfig">
                                </editor>
                            </div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="card">
                            <div class="card-header">
                                Közzététel
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Állapot:</label>
                                    <select class="form-control" v-model="status">
                                        <option value="draft">Vázlat</option>
                                        <option value="published">Publikus</option>
                                        <option value="timed">Időzített</option>
                                    </select>
                                </div>

                                <div class="form-group" :class="{'collapse': !showPublishTiming}">
                                    <label>
                                        Publikálás időpontja:
                                    </label>

                                    <datetime type="datetime"
                                        v-model="post.published_at"
                                        :min-datetime="(new Date).toISOString()"
                                        format="yyyy-MM-dd HH:mm"
                                        input-class="form-control">
                                    </datetime>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <div class="form-group">
                                    <label for="titleInput">Cím:</label>
                                    <input type="text"
                                        class="form-control"
                                        id="titleInput"
                                        v-model="post.title">
                                </div>

                                <div class="form-group">
                                    <label for="slugInput">Slug:</label>
                                    <input type="text"
                                        class="form-control"
                                        id="slugInput"
                                        v-model="post.slug"
                                        @input="updateCanonical">
                                </div>

                                <div class="form-group">
                                    <label for="descriptionInput">Meta leírás:</label>
                                    <textarea class="form-control"
                                        id="descriptionInput"
                                        rows="4"
                                        v-model="post.description">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>

            <tab id="categorization" name="Kategorizálás">
                <div class="card">
                    <div class="card-header">
                        Kategória
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <treeselect v-model="post.category"
                                :options="categories"
                                :multiple="false"
                                :clearable="false"
                                :normalizer="normalizeCategories">
                            </treeselect>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        Címkék
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <treeselect v-model="post.tags"
                                :options="tags"
                                :multiple="true"
                                :normalizer="normalizeTags">
                            </treeselect>
                        </div>
                    </div>
                </div>
            </tab>

            <tab id="media" name="Média">
                <media-editor :images="post.images"
                    @add="showLibrary(true)">
                </media-editor>
            </tab>
        </tabs>

        <vue-medialibrary-manager :selectable="true"
            v-if="showMediaLibrary"
            @close="showMediaLibrary=false"
            @select="selectImage">
        </vue-medialibrary-manager>
    </form>
</template>

<script>
import Vue from 'vue'
import Editor from 'vue-editor-js'
import ls from '../../services/ls.js'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import MediaLibrary from '../../components/MediaLibrary'
import { Tabs, Tab } from 'vue-tabs-component'
import Treeselect from '@riophae/vue-treeselect'
import toolConfig from '../../helpers/toolConfig.js'
import MediaEditor from '../../components/MediaEditor'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VariationEditor from '../../components/VariationEditor'


Vue.use(Editor)
Vue.use(MediaLibrary, {
    API_URL: '/api/admin/media'
});

export default {
    props: {
        original: { type: [Object], required: true },
        save: { type: [Function], required: true },
    },
    components: {
        Tab,
        Tabs,
        Datetime,
        Treeselect,
        MediaEditor,
        VariationEditor,
    },
    data () {
        return {
            post: {
                tags: [],
                title: 'Új bejegyzés',
                slug: 'uj-bejegyzes',
                description: '',
                published_at: null,
                canonical: 'posts/uj-bejegyzes',
                images: [],
                category: null,
                relations: [],
            },
            loadStatus: 0,
            status: 'draft',
            showPublishTiming: false,
            site: null,
            domain: null,
            tags: [],
            categories: [],
            libraryTarget: 'content',
            showMediaLibrary: false,
            selectCallback: () => {},
            editorConfig: {
                tools: toolConfig.get(this),
                onReady: () => {
                    this.loadStatus++
                },
                data: {},
                autofocus: true,
                placeholder: 'Write your content here'
            },
            tooltips: {
                attributes: {
                    content: 'A megadott azonosítókhoz létre kell hozni egy fordítást is a Vezérlőpult/Fordítások menüpontban'
                }
            }
        }
    },
    methods: {
        showLibrary(gallery=false){
            this.libraryTarget = gallery ? 'gallery' : 'content'
            this.showMediaLibrary = true
        },
        setSelectCallback(f){
            this.selectCallback = f
        },
        selectImage(image){
            if(this.libraryTarget=='gallery'){
                image.highlight = false
                this.post.images.push(image)
            }else{
                this.selectCallback(image)
            }

            this.showMediaLibrary = false
        },
        updateCanonical(){
            this.post.canonical = `${this.domain}/posts/${this.post.slug}`
        },
        loadRelations(){
            if(this.post.relations == undefined){
                this.post.relations = {}
            }

            this.post.images = this.post.relations?.images ? this.post.relations.images : []
        },
        loadEditor(){
            let data = this.post.content.map(o => {
                return o.content
            })

            this.$refs.editor.state.editor.render({
                blocks: data,
                version: '2.8.1',
                time: (new Date).getTime()
            })
        },
        loadCategories(){
            axios.get('/api/admin/categories', {
                params: {
                    with: 'children',
                    filters: {
                        site: this.site,
                        parent: 'posts',
                    }
                }
            })
            .then(results => {
                this.categories = results.data.data
            })
        },
        normalizeCategories(node){
            var cat = {
                id: node.id,
                label: node.name ? node.name : '',
            }

            if(node?.relations?.children.length > 0){
                cat.children = node.relations.children
            }

            return cat
        },
        loadTags(){
            axios.get('/api/admin/tags', {
                params: {
                    filters: {
                        site: this.site,
                    }
                }
            })
            .then(results => {
                this.tags = results.data.data
            })
        },
        normalizeTags(node){
            return {
                id: node.id,
                label: node.name,
            }
        },
        submit(){
            this.$emit('saving', true)

            this.$refs.editor.state.editor.save().then(data => {
                this.save(this.post, data.blocks)
            })
        },
    },
    created() {
        this.site = ls.get('site')
        this.domain = ls.get('siteDomain')
        this.loadCategories()
        this.loadTags()
    },
    watch: {
        status(newValue){
            if(newValue == 'draft'){
                this.post.published_at = null
            }else if(newValue == 'published' || !this.post.published_at){
                this.post.published_at = (new Date).toISOString()
            }

            this.showPublishTiming = newValue == 'timed'
        },
        original(newValue){
            if(!this.original) return

            this.loadStatus++
        },
        loadStatus(newValue){
            if(newValue < 2) return

            this.post = this.original

            this.loadRelations()

            this.loadEditor()

            this.updateCanonical()

            this.post.category = this.post.relations.category
                ? this.post.relations.category.id
                : null

            this.post.tags = this.post.relations.tags
                ? this.post.relations.tags.map(tag => tag.id)
                : []

            if(this.post.published_at != null){
                let date = new Date(this.post.published_at)
                let now = new Date()

                if(date > now){
                    this.status = 'timed'
                    this.post.published_at = date.toISOString()
                }else{
                    this.status = 'published'
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
